module.exports = __webpack_public_path__ + "b0128d52f2ac94753035bc417d780cd9.png";